module.exports = __webpack_public_path__ + "img/1.7611824e.jpg";